'use client';
import { createGlobalStyle } from "styled-components";

export const SelectGlobalStyle = createGlobalStyle`
    /* 포탈 루트 자체 z-index 올리기 */
    .react-select__menu-portal {
        z-index: 9999;
    }

    /* 포탈 안에 뜨는 메뉴 스타일 */
    .react-select__menu-portal .react-select__menu {
        background-color: #fff;
        border-radius: 10px;
        box-shadow: 1px 1px 2px 0 rgba(0, 0, 0, 0.08), 0 2px 8px -4px rgba(0, 0, 0, 0.20);
        overflow: hidden;
        padding: 0;
        width: 100%;
    }

    .react-select__menu-portal .react-select__menu-list {
        padding: 0;
        width: 100%;
        overflow-y: auto;
    }

    .react-select__menu-portal .react-select__option {
        font-size: 14px;
        font-weight: 400;
        line-height: 24px;
        padding: 0 16px;
        height: 30px;
        color: #333;
        background-color: #fff;
        //background-color: transparent;
        //color: black;
        //text-align: left;
        display: flex;
        align-items: center;
        //justify-content: space-between;
        //width: 100%;
        //cursor: pointer;
        
    }
    .react-select__menu-portal .react-select__option + .react-select__option{
        border-top: 1px solid #E6E6E6;
    }
    .react-select__menu-portal .react-select__option{
        cursor: pointer;
    }
    .react-select__menu-portal .react-select__option:hover {
        background-color: #e1f2e9; /* 대충 hover 색 */
        color: #333;
    }

    /* ✅ 선택된 옵션 색 여기서 강제로 */
    .react-select__menu-portal .react-select__option--is-selected,
    .react-select__menu-portal .react-select__option--is-selected.react-select__option--is-focused {
        background-color: #e1f2e9 !important;
        color: #333 !important;
    }
`;
